import { withViewModel } from '../../../infrastructure/components/with-view-model';
import { AccountFormVM } from './account-form.viewmodel';
import { AccountFormPresentation } from './_account-form-presentation/account-form-presentation';

interface IProps {
    accountId: number;
    reservedSubdomains: string[];
    fetchAccountsList: () => void;
    closeEditAccountForm?: (accountId: string) => void;
}

const AccountFormContainer = withViewModel(
    AccountFormPresentation,
    (props: IProps) => {
        const accountFormVM = new AccountFormVM(props.fetchAccountsList, props.closeEditAccountForm);
        accountFormVM.initializeParams(props.reservedSubdomains);
        accountFormVM.setAccount(props.accountId);
        return accountFormVM;
    },
    props => [props.accountId],
);

export { AccountFormContainer as AccountForm };
